import { FunctionComponent } from 'react';
import { Flex, Box } from '@rebass/emotion';

import { FormattedMessage } from 'react-intl';
import Icon from './icons';
import messages from './ProductUpgradeMessage.messages';
import { PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as MagentoProductVariant } from '../../hook/__generated__/PricingPageShopProduct';
import useUpgradePaths from '../../hook/useUpgradePaths';
import UpdateLink from './UpdateLink';

const QualifiesForUpdateMessage: FunctionComponent<{
  variants: Array<MagentoProductVariant | null> | null;
  selectVariant: (value: MagentoProductVariant) => void;
}> = ({ variants, selectVariant }) => {
  const { upgradeVariants } = useUpgradePaths();
  const getProductPrice = (item) =>
    item?.product?.priceRange?.minimumPrice?.finalPrice?.value;

  const updateVariant = variants?.reduce(
    (acc, item): MagentoProductVariant | null => {
      const sdbsId = item?.product?.sdbsId;
      if (!sdbsId) {
        return null;
      }
      if (
        upgradeVariants &&
        sdbsId in upgradeVariants &&
        (!acc || (acc && getProductPrice(item) < getProductPrice(acc)))
      ) {
        return item;
      }
      return acc;
    },
    null
  );

  const updateSdbsId = updateVariant && updateVariant.product?.sdbsId;

  const matchingUpdate = updateSdbsId && upgradeVariants?.[updateSdbsId];

  if (updateVariant && matchingUpdate) {
    return (
      <Flex data-testid="upgrade-message-qualifies-for-update">
        <Box mr={2}>
          <Icon width={25} type="exclamation-mark-yellow" />
        </Box>
        <Box flex={1}>
          <FormattedMessage
            {...messages.qualifiesForUpdate}
            values={{
              baseProduct: matchingUpdate.baseProduct.title,
              UpdateButton: (
                <UpdateLink
                  selectVariant={selectVariant}
                  updateVariant={updateVariant}
                />
              ),
            }}
          />
        </Box>
      </Flex>
    );
  }

  return null;
};

export default QualifiesForUpdateMessage;
